import React, { useState } from "react";
import "./ListsStyles.css";
import moment from "moment";
import useFavorites from "../../../utils/useFavorites";
import { imageLoader } from "../../../utils/imageLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  addOpenLot,
  setActiveOnglet,
  fetchSingleLot,
  fetchLots,
} from "../../../redux/actions/immobilierActions";

const ListeLots = ({
  fav = true,
  lots,
  setDisplayedLot,
  openNewtab = true,
}) => {
  const {
    favorites,
    isProgramInFavorites,
    handleAddToFavorites,
    isLotInFavorites,
  } = useFavorites();
  const dispatch = useDispatch();
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed
  );

  // Add state for sorting
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "desc",
  });
  const handleLotClick = async (documentId) => {
    dispatch(addOpenLot(documentId));
    dispatch(fetchSingleLot(documentId));
    dispatch(setActiveOnglet(`lot-${documentId}`));
  };
  const changeDisplayedLot = (lot) => {
    setDisplayedLot(lot);
    const targetElement = document.getElementById("lotsDetails");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Function to handle sort request
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    // Map UI keys to API field names
    let sortField = key;

    // Dispatch action to fetch sorted lots with the direction parameter
    dispatch(fetchLots(1, 25, sortField, "", direction));
  };

  // Helper function to render sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) {
      return <img src="/icons/sorts.svg" alt="sort" className="sort-icon" />;
    }
    return sortConfig.direction === "asc" ? (
      <img
        src="/icons/sort_up.svg"
        alt="sort ascending"
        className="sort-icon"
      />
    ) : (
      <img
        src="/icons/sort_down.svg"
        alt="sort descending"
        className="sort-icon"
      />
    );
  };

  return (
    <div className="">
      <div className="table mt-4">
        {/* Header */}
        <div className="table-lot-header pink text-center ">
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("reference")}
          >
            Lot {getSortIndicator("reference")}
          </div>
          <div className="table-cell">Programme</div>
          <div className="table-cell">Dispositif</div>
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("typology")}
          >
            Type {getSortIndicator("typology")}
          </div>
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("surface")}
          >
            Surface (m2) {getSortIndicator("surface")}
          </div>
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("floor")}
          >
            Étage {getSortIndicator("floor")}
          </div>
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("price_total")}
          >
            Prix {getSortIndicator("price_total")}
          </div>
          <div className="table-cell">Prix/m²</div>
          <div
            className="table-cell sortableHeaderStyle"
            onClick={() => requestSort("rent")}
          >
            Loyer {getSortIndicator("rent")}
          </div>
          <div className="table-cell">Honoraires</div>
          <div className="table-cell">Favoris</div>
        </div>

        {/* Rows */}
        {lots?.length > 0 ? (
          lots.map((lot) => (
            <div
              key={lot.documentId}
              className="table-lot-row cursor-pointer hoverborder"
              /* onClick={() => handleLotClick(lot?.documentId)} */
              onClick={() => {
                openNewtab
                  ? handleLotClick(lot?.documentId)
                  : changeDisplayedLot(lot);
              }}
            >
              {/* Lot */}
              <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="plan-image position-relative">
                    <span
                      className={
                        lot?.disponibility?.disponibilite === "Disponible"
                          ? "position-absolute top-0 start-0 bg-green py-1 px-2 radius5 fs11 "
                          : "position-absolute top-0 start-0 bg-yellow py-1 px-2 radius5 fs11 "
                      }
                    >
                      {lot?.disponibility?.disponibilite === "Disponible"
                        ? "Disponible"
                        : "Optionné"}
                    </span>
                    {lot?.images?.length > 0 &&
                    lot?.images[0]?.image?.length > 0 ? (
                      <img
                        src={imageLoader(lot?.images[0]?.image[0]?.url)}
                        alt=""
                        className="radius5"
                      />
                    ) : (
                      <img
                        src="/assets/imgNotFound.webp"
                        alt=""
                        className="radius5"
                      />
                    )}
                  </div>
                  <div>
                    <p
                      className="mb-0 fs16 darkGrey semibold"
                      title={lot.reference}
                    >
                      {lot.reference}
                    </p>
                    {/* <p className="text-muted mb-0 fs11 darkGrey regular">
                      {lot.availability === "available"
                        ? "Disponible"
                        : "Optionné"}
                    </p> */}
                  </div>
                </div>
              </div>

              {/* Programme */}
              <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="program-image">
                    {lot?.images?.[1]?.image?.[0]?.url ? (
                      <img
                        src={imageLoader(lot.images[1].image[0].url)}
                        alt=""
                      />
                    ) : lot?.images?.[0]?.image?.[0]?.url ? (
                      <img
                        src={imageLoader(lot.images[0].image[0].url)}
                        alt=""
                      />
                    ) : (
                      <img
                        src="/assets/imgNotFound.webp"
                        alt=""
                        className="radius5"
                      />
                    )}
                  </div>

                  <div className="d-flex flex-column text-start">
                    <div>
                      <p
                        className="mb-0 fs16 darkGrey semibold text-wrap "
                        title={lot.programme_parent?.name}
                      >
                        {lot.programme_parent?.name}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent?.address}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 fs11 darkGrey semibold">
                        {lot.programme_parent?.municipality}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent?.delivery_date
                          ? moment(lot.programme_parent?.delivery_date).format(
                              "YYYY"
                            ) +
                            " T-" +
                            moment(
                              lot.programme_parent?.delivery_date
                            ).quarter()
                          : "NC"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Dispositif */}
              <div className="table-cell">
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex flex-column justify-content-between gap6">
                    {lot.project_types?.length > 0 ? (
                      lot.project_types.map((badge) => (
                        <span
                          key={badge.documentId}
                          className="fs11 bg-green radius5 py-1 px-2 text-white"
                          title={badge.label}
                        >
                          {badge.label}
                        </span>
                      ))
                    ) : (
                      <span className="fs11 bg-green radius5 py-1 px-2 text-white">
                        NC
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Type */}
              <div className="table-cell text-capitalize">
                {lot.typology ? lot.typology : "NC"}
              </div>

              {/* Surface */}
              <div className="table-cell">
                {lot.surface ? lot.surface : "NC"}
              </div>

              {/* Étage */}
              <div className="table-cell">
                {lot.floor === null
                  ? "NC"
                  : lot.floor == 0
                  ? "RDC"
                  : lot.floor == 1
                  ? "1er"
                  : lot.floor + "ème"}
              </div>

              {/* Prix */}
              <div className="table-cell">
                <div className="text-center">
                  <small className="text-muted fs11 regular darkGrey">
                    {"TVA " +
                      (lot.price_vat_rate ? lot.price_vat_rate + "%" : "NC") +
                      ""}
                  </small>
                  <p className="mb-0 fs16 semibold darkGrey">
                    {Intl.NumberFormat("fr-FR").format(lot.price_total) + " €"}
                  </p>
                </div>
              </div>

              {/* Prix/m² */}
              <div className="table-cell">
                {lot.surface
                  ? (lot.price_total / lot.surface).toFixed(1) + " €"
                  : "NC"}
              </div>

              {/* Loyer */}
              <div className="table-cell">
                {lot.rent ? lot.rent + " €" : "NC"}
              </div>

              {/* Honoraires */}
              <div className="table-cell">
                {isDisplayed
                  ? lot.commission
                    ? lot.commission.match(/\d+(\.\d+)?/)[0] + "%"
                    : "NC"
                  : "***"}
              </div>

              {/* Action */}
              <div className="table-cell">
                <img
                  src={
                    isLotInFavorites(lot.documentId)
                      ? "./icons/favorite-filled.svg"
                      : "./icons/favorite-outline.svg"
                  }
                  alt="favorite"
                  height={35}
                  width={35}
                  className="cursor-pointer p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToFavorites(lot.documentId, "Lot");
                  }}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">Pas de lots</div>
        )}
      </div>
    </div>
  );
};

export default ListeLots;
